import { ThemeProvider } from 'styled-components';

import AuthProvider from './context/AuthProvider';

import { theme } from './theme';

const AppProviders = ({ children }: { children: React.ReactNode }): React.ReactElement => (
  <ThemeProvider theme={theme}>
    <AuthProvider>
      <>{children}</>
    </AuthProvider>
  </ThemeProvider>
);

export default AppProviders;
